// src/payments/TokenProvider.jsx
import { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "../auth/AuthGate";

const TokenContext = createContext({ tokenBalance: null, refreshBalance: () => {} });
export const useTokens = () => useContext(TokenContext);

export default function TokenProvider({ children }) {
  const { user, getToken } = useAuth();
  const [tokenBalance, setTokenBalance] = useState(null);

  const fetchBalance = async () => {
    if (!user) return;
    try {
      const res  = await fetch("/.netlify/functions/wc-token-balance", {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      const data = await res.json();
      if (res.ok) setTokenBalance(data.tokensRemaining);
    } catch { /* non-fatal */ }
  };

  useEffect(() => { fetchBalance(); }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  // Refresh balance after Stripe payment redirect
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("payment") === "success") {
      window.history.replaceState({}, "", window.location.pathname);
      setTimeout(fetchBalance, 2000); // Give webhook time to fire
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TokenContext.Provider value={{ tokenBalance, refreshBalance: fetchBalance }}>
      {children}
    </TokenContext.Provider>
  );
}
